import * as React from "react";
import Component from "../../AbstractComponent";
// import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
// import Select from "../../Partials/Material/Select";
import TextField from "../../Partials/Material/TextField";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
// import MenuItem from '@material-ui/core/MenuItem';
// import PersonLookup from "../../Partials/Lookup/PersonLookup";
// import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import Searchbar from "../../Partials/Searchbar/Searchbar";
import { Company } from "../../../Entity/Entities/Company/Company";

export default class TaskDetailsEditable extends Component {
  constructor(public props) {
    super(props);
  }

  public render() {

    return (
      <>
        {/* {this.props.selectedEntityForTask && (
        <div className="read-only-wrapper" style={{paddingTop: "32px"}}>
          <div style={{color: "gray", fontSize: "14px", marginRight: "5px"}}>
            {this.trans("page/taskupdate-hint/taskfor", {entity: this.props.selectedEntityForTask.nameOfEntity})}
          </div>
          <div className="margin-wrapper">
            <div className="link-to-entity" onClick={() => this.redirect(`/app/${this.props.selectedEntityForTask.nameOfEntity === "Activity" ? this.props.selectedEntityForTask.nameOfEntity.toLowerCase() : this.props.selectedEntityForTask.nameForUrl}/update/${this.props.selectedEntityForTask.id}`)}>
              {this.props.selectedEntityForTask && this.props.selectedEntityForTask.displayName}
            </div>
          </div>
        </div>
      )} */}

        {this.props.task && this.props.task.creator &&
          <div className="read-only-wrapper" style={{ marginTop: "35px", paddingTop: "0px" }}>
            <div style={{ color: "gray", fontSize: "14px", marginRight: "5px" }}>
              {`${this.trans("registered-by")}: `}
            </div>
            <div className="margin-wrapper">
              <div className="link-to-entity" onClick={() => this.redirect(`/app/user/update/${this.props.task && this.props.task.createdBy}`)}>
                {this.props.task && this.props.task.creator && this.props.task.creator.displayName}
              </div>
            </div>
          </div>
        }

        <div className="row" >
          <div className="grid"></div>
          <div className="grid">
            <div style={{ position: "absolute", right: "20px", top: "35px" }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.props.reacted}
                    onChange={this.props.changeStatus}
                    color="primary"
                  />
                }
                label={this.trans("status-finished")}
              />
            </div>


            <div className="search-bar-container">
              <Searchbar
                {...this.props}
                id="selectedEntityForNewTask"
                className="scroll-to-objectId"
                floatingLabelText={this.trans("object")}
                allResults={true}
                objectField={true}
                onChange={this.props.selectEntityForTask}
                onClear={this.props.clearEntityForTask}
                searchText={this.props.selectedEntityForTask ? `${this.props.selectedEntityForTask?.nameOfEntity}, ${this.props.selectedEntityForTask?.displayName}` : undefined}
                selectedEntity={this.props.selectedEntityForTask}
                error={this.getErrorFor("objectId")}
                searchParameter={"objectForTaskSearch"}
                disabled={this.state.disableObjectField}
                styleInModal={"pick-object-modal"}
                showClickThroughLink={true}
              />
            </div>

            {/* <Select
            className="form-element full-size scroll-to-eventTypeId"
            error={this.getErrorFor("eventTypeId")}
            value={this.props.eventTypeId}
            onChange={this.props.updateEventTypeId}
            htmlFor="eventTypeId"
            label={this.trans("label-type")}
            name="eventTypeId" 
            id="eventTypeId"
          > */}
            {/* TODO fix hardcoded value */}
            {/* <MenuItem
              key={`eventTypeId-${35}`}
              value={35}
            >
              {this.trans("task")}
            </MenuItem>
            <MenuItem
              key={`eventTypeId-${38}`}
              value={38}
            >
              {this.trans("incident")}
            </MenuItem>
          </Select> */}

            <TextField
              autoComplete="off"
              className="form-element full-size scroll-to-name"
              type="text"
              label={this.trans("label-description")}
              value={this.props.instructions}
              onChange={this.props.setTaskName}
              autoFocus={true}
              variant="standard"
              disabled={this.props.removed}
              style={{ marginBottom: "10px" }}
              multiline
              rowsMax="25"
              rows="1"
              error={!!this.getErrorFor("content.name")}
            />
            {!!this.getErrorFor("content.name") && <div className="component-error-text">{this.getErrorFor("content.name")}</div>}

            <div className="search-bar-container">

              <Searchbar
                {...this.props}
                name="personId"
                className="scroll-to-mainTenantContactId"
                id="selectedTenantForContract"
                ref="PersonLookup"
                floatingLabelText={this.trans("reported-by")}
                allResults={true}
                objectField={true}
                onChange={this.props.selectReporter}
                onClear={this.props.clearReporter}
                selectedEntity={this.props.reporter instanceof Company
                  ? this.props.reporter
                  : this.props.reporter?.company
                    ? this.props.reporter?.company
                    : this.props.reporter}
                searchParameter={"contactsSearch"}
                error={this.getErrorFor("mainTenantContactId") || this.getErrorFor("contactForContracts[0].contactId")}
                searchText={
                  this.props.reporterDisplayName
                }
                styleInModal={"pick-object-modal"}
                openCoachCreateNewEntity={this.props.openTaskReporterCoachDialog}
                createButton={"button-add-person"}
                showClickThroughLink={true}
              />
            </div>

            <div className="search-bar-container">
              <Searchbar
                {...this.props}
                name="personId"
                className="scroll-to-mainTenantContactId"
                id="selectedTenantForContract"
                ref="PersonLookup"
                floatingLabelText={this.trans("assignee") + this.trans("field/optional")}
                allResults={true}
                objectField={true}
                onChange={this.props.selectPerson}
                onClear={this.props.clearPerson}
                selectedEntity={
                  this.props.executor instanceof Company
                    ? this.props.executor
                    : this.props.executor?.company
                      ? this.props.executor?.company
                      : this.props.executor
                }
                searchText={
                  this.props.executorDisplayName
                }
                searchParameter={"contactsSearch"}
                error={this.getErrorFor("mainTenantContactId") || this.getErrorFor("contactForContracts[0].contactId")}
                styleInModal={"pick-object-modal"}
                openCoachCreateNewEntity={this.props.openTaskExecutorCoachDialog}
                createButton={"button-add-person"}
                showClickThroughLink={true}
              />
            </div>
            {/* 
            <PersonLookup
              {...this.props}
              autoSelectId={this.props.reporterId}
              isInlineBlock={true}
              width="100%"
              containerWidth="100%"
              ref="PersonLookup"
              floatingLabelText={this.trans("reported-by") + this.trans("field/optional")}
              labelText={this.trans("reporter") + this.trans("field/optional")}
              onSelect={this.props.selectReporter}
              onClear={this.props.clearReporter}
              // forceUpdatePage={true}
              saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "taskUpdate", "reporter")}
              buttonLabel={this.trans("button-add-person")}
              noResultText={this.trans("dropdown-person-notfound")}
              templateFor={"person"}
              includeUsers={true}
              shouldOpenCoachModal={true}
              shouldRedirectToCreatePage={false}
              openTaskExecutorCoachDialog={this.props.openTaskReporterCoachDialog}
            />

            <PersonLookup
              {...this.props}
              autoSelectId={this.props.executorId}
              isInlineBlock={true}
              width="100%"
              containerWidth="100%"
              ref="PersonLookup"
              floatingLabelText={this.trans("to-do-by") + this.trans("field/optional")}
              labelText={this.trans("assignee") + this.trans("field/optional")}
              onSelect={this.props.selectPerson}
              onClear={this.props.clearPerson}
              saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "taskUpdate", "executor")}
              buttonLabel={this.trans("button-add-executor")}
              noResultText={this.trans("textfield-no-executor-found-click-add")}
              templateFor={"executor"}
              disabled={this.props.removed}
              includeUsers={true}
              shouldOpenCoachModal={true}
              shouldRedirectToCreatePage={false}
              openTaskExecutorCoachDialog={this.props.openTaskExecutorCoachDialog}
            /> */}


            {/* <DatePickerComponent
            {...this.props}
            className="scroll-to-executionDate"
            label={this.trans("show-me-from") + this.trans("field/optional")}
            initialDate={this.props.executionDate}
            onChange={date => this.props.selectDate(date, "executionDate")}
            minDate={new Date()}
            minDatePlusDays={0}
            clearButton={true}
            disabled={this.props.removed}
            error={this.getErrorFor("executionDate")}
          /> */}
          </div>
        </div>
      </>
    );
  }
}
